import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useBlocker } from '@tanstack/react-router';

const useNavigationWarning = (message = 'You have unsaved changes. Are you sure you want to leave this page?') => {
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        window.onbeforeunload = isDirty && (() => message);

        return () => {
            window.onbeforeunload = null;
        };
    }, [isDirty]);

    const { proceed, reset, status } = useBlocker({
        shouldBlockFn: () => isDirty,
        withResolver: true,
    });

    const prompt = (
        <>
            {status === 'blocked' && (
                <Dialog open={true} onClose={reset}>
                    <DialogTitle>Unsaved Changes</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{message}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={reset}>Cancel</Button>
                        <Button onClick={proceed} autoFocus>
                            Leave Page
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );

    return [prompt, () => setIsDirty(true), () => setIsDirty(false)];
};

export default useNavigationWarning;
